var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducationBlack2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#182828;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88,195V161h20.39v6.8H94.82v6.79h13.59v6.8H94.82V195Zm20.39-27.18h6.79v6.79h-6.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.59,188.2h13.59V195H128.79V161h6.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.93,195V167.82h6.8v6.79h13.59v-6.79h6.79V195h-6.79V181.41H169.73V195Zm6.8-34v6.8h13.59V161Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.54,161h6.79v6.8h-6.79Zm6.79,6.8h6.8v6.79h-6.8Zm6.8,27.18V174.61h6.79V195Zm6.79-27.18h6.8v6.79h-6.8Zm6.8-6.8h6.79v6.8h-6.79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.84,254.56V217h9.39v9.39H116V217h9.4v37.58H116V235.77H97.23v18.79Zm9.39-47V217H116v-9.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144,254.56v-47h28.18V217H153.37v9.39h18.79v9.4H153.37v18.79Zm18.79-18.79h9.39v9.39h-9.39ZM172.16,217h9.4v9.39h-9.4Zm0,28.18h9.4v9.4h-9.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.35,254.56v-47h28.18V217H209.74v28.18h18.79v9.4ZM237.93,217v28.18h-9.4V217Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 269.56,
    y: 161.02,
    width: 6.8,
    height: 93.51
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.9,163.26h48.61v16.59H327.73V196h31.78v16.28H327.73v23.43h31.78v16.65H310.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.37,163.26h20.09q19.41,0,28.85,4.82t15.54,15.65Q446,194.56,446,209A51.1,51.1,0,0,1,442.55,228a39.3,39.3,0,0,1-9.44,14.32,33.32,33.32,0,0,1-13,7.87q-7,2.18-24.31,2.18H375.37Zm16.83,16.35v56.18h7.87q11.63,0,16.86-2.67a20.16,20.16,0,0,0,8.57-9q3.33-6.32,3.33-15.52,0-14.17-7.93-22-7.14-7-22.95-7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.52,163.26h17v57.59q0,7.44,1.31,10.53a10.5,10.5,0,0,0,4.29,4.93,13.55,13.55,0,0,0,7.24,1.84,14.1,14.1,0,0,0,7.72-2.05,10.84,10.84,0,0,0,4.48-5.24q1.24-3.17,1.24-12.13V163.26h17v53.1q0,13.44-1.51,18.64a26.38,26.38,0,0,1-5.78,10.05,27,27,0,0,1-9.84,7.18,33.46,33.46,0,0,1-13,2.33,31.29,31.29,0,0,1-16.86-4.45A25.93,25.93,0,0,1,464.61,239q-3.09-6.69-3.09-22.61Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M623.35,178.91l-11.86,11.31q-12.09-12.79-27.22-12.79A29.83,29.83,0,0,0,554,207.67a31.83,31.83,0,0,0,3.87,15.82,27.8,27.8,0,0,0,11,10.85,31.85,31.85,0,0,0,15.73,3.93,32.36,32.36,0,0,0,13.48-2.75q6.12-2.76,13.43-10l11.5,12q-9.87,9.63-18.65,13.35a50.76,50.76,0,0,1-20,3.73q-20.76,0-34-13.17t-13.23-33.75a46.14,46.14,0,0,1,6-23.67,44.85,44.85,0,0,1,17.26-16.65,48.59,48.59,0,0,1,24.18-6.3,51.4,51.4,0,0,1,38.81,17.89Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M665.35,163.26h17.19l34.25,89.06H699.18l-7-18.34H655.87l-7.25,18.34H631Zm8.7,23.61L662.1,217.45h23.83Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M721.12,163.26h49.22V180H754.12v72.35h-17.2V180h-15.8Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M780.76,163.26h16.83v89.06H780.76Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M858.7,161q18.9,0,32.5,13.69t13.6,33.35q0,19.5-13.42,33a44.18,44.18,0,0,1-32.56,13.5q-20.05,0-33.32-13.86A46.8,46.8,0,0,1,858.7,161Zm-.18,16.59a28,28,0,0,0-20.79,8.6q-8.41,8.59-8.42,21.85,0,14.77,10.61,23.37a29,29,0,0,0,18.9,6.72,27.6,27.6,0,0,0,20.55-8.72,31.43,31.43,0,0,0-.06-43A27.9,27.9,0,0,0,858.52,177.61Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M920.85,163.26h16.26l38.1,58.61V163.26h16.95v89.06h-16.3L937.8,193.9v58.42H920.85Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationBlack2);
export default __webpack_public_path__ + "static/media/Education - Black (2).82187a223d20babf76bcc03716c67e78.svg";
export { ForwardRef as ReactComponent };